import React, { useEffect } from "react";
import { Sprint } from "../types/Sprint";
import { Button, OverlayTrigger, Popover, Table } from "react-bootstrap";
import { Edit, Trash } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "../redux/reducers";
import { fetchSprints } from "../redux/actions/SprintAction";
import { fetchProjects } from "../redux/actions/projectAction";
import { AppDispatch } from "../redux/store";
import "../styles/EmployeeList.css";

interface Props {
  sprints: Sprint[];
  onEdit: (sprint: Sprint) => void;
  onDelete: (id: number) => void;
}

const SprintList: React.FC<Props> = ({ sprints, onEdit, onDelete }) => {
  const dispatch = useDispatch<AppDispatch>();

  const editPopover = (
    <Popover id="popover-edit">
      <Popover.Body>Edit details</Popover.Body>
    </Popover>
  );
  const deletePopover = (
    <Popover id="popover-delete">
      <Popover.Body>Delete details</Popover.Body>
    </Popover>
  );
  const projects = useSelector((state: StoreState) => state.project);

  useEffect(() => {
    dispatch(fetchSprints());
  }, []);

  useEffect(() => {
    dispatch(fetchProjects());
  }, []);
  return (
    <Table className="custom-employee-table" responsive>
      <thead>
        <tr>
          <th>S.No</th>
          <th>Sprint</th>
          <th>Project</th>
          <th>Start</th>
          <th>End</th>
          <th>Status</th>
          <th>Remarks</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {sprints.map((s, index) => {
          const project = projects.find(
            (p) => Number(p.id) === Number(s.projectId),
          );
          const projectName = project?.name;

          return (
            <tr key={s.id}>
              <td>{index + 1}</td>
              <td>{s.sprint}</td>
              <td>{projectName}</td>
              <td>{s.startDate}</td>
              <td>{s.endDate}</td>
              <td>{s.status}</td>
              <td>{s.remarks}</td>
              <td className="d-flex no-wrap border-0 justify-content-center">
                <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement="top"
                  overlay={editPopover}
                >
                  <Button
                    variant="warning"
                    className="mr-2"
                    onClick={() => onEdit(s)}
                    style={{
                      padding: "5px",
                      borderRadius: "5px",
                    }}
                  >
                    <Edit />
                  </Button>
                </OverlayTrigger>
                <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement="top"
                  overlay={deletePopover}
                >
                  <Button
                    variant="danger"
                    onClick={() => onDelete(s.id)}
                    style={{
                      padding: "5px",
                      borderRadius: "5px",
                    }}
                  >
                    <Trash />
                  </Button>
                </OverlayTrigger>
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

export default SprintList;
